import { ReactNode } from 'react';

import classNames from 'classnames';

import { AppearInView } from '@/blocks/animations/AppearInView';
import { Separator } from '@/blocks/components/Separator';
import { WithClassName } from '@/blocks/components/types';
import { EventBlockNames } from '@/providers/analytics/types';
import context from '@/styles/contexts.module.scss';
import typography from '@/styles/typography.module.scss';

import styles from './TopIconCard.module.scss';

const sizes = {
  s: styles.sizeS,
  m: styles.sizeM,
};

export const iconBgs = {
  primary: styles.bgPrimary,
  pink: styles.bgPink,
  orange: styles.bgOrange,
  red: styles.bgRed,
  green: styles.bgGreen,
  yellow: styles.bgYellow,
  violet: styles.bgViolet,
};

export type TopIconCardProps = {
  title: ReactNode;
  description?: ReactNode;
  contentSlot?: ReactNode;
  icon: ReactNode;
  iconBg?: keyof typeof iconBgs;
  size?: keyof typeof sizes;
  separator?: boolean;
  classes?: {
    title?: string;
    description?: string;
  };
} & WithClassName;

export const TopIconCard = ({
  title,
  description,
  icon,
  iconBg = 'primary',
  size = 's',
  separator = false,
  contentSlot,
  className,
  classes,
}: TopIconCardProps) => {
  return (
    <div className={classNames(context.light, styles.wrapper, className)}>
      <AppearInView className={classNames(styles.iconBox, iconBgs[iconBg])} initialScale={0.8} duration={0.6}>
        {icon}
      </AppearInView>
      <div className={classNames(styles.content, sizes[size])}>
        <h3 className={classNames(classes?.title || typography.h5)}>{title}</h3>
        {separator && <Separator className={styles.separator} />}
        {description && (
          <p className={classNames(classes?.description || typography.bodyM, styles.description)}>
            {description}
          </p>
        )}
        {contentSlot}
      </div>
    </div>
  );
};

export type TopIconCardListProps = {
  list: string[];
};

export const TopIconCardList = ({ list }: TopIconCardListProps) => {
  return (
    <ul className={styles.cardList} data-event-block-name={EventBlockNames.icon_card_list}>
      {list.map((listItem, i) => (
        <li key={i} className={styles.listItem}>
          <span className={typography.bodyM}>{listItem}</span>
        </li>
      ))}
    </ul>
  );
};
